var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProportionalArrowsHideIcon = function SvgProportionalArrowsHideIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c6.075 0 11 3.582 11 8 0 1.197-.361 2.333-1.01 3.352a7.613 7.613 0 0 0-1.127-.806c.489-.79.757-1.653.757-2.546 0-3.544-4.23-6.62-9.62-6.62-5.39 0-9.62 3.076-9.62 6.62 0 1.74 1.012 3.414 2.84 4.672l.69.475-.102.83a37.164 37.164 0 0 1-.392 2.443l-.112.56.063-.03c.974-.477 2.016-1.124 3.124-1.943l.372-.279.467-.357.505.078-.216.551.253.642c.029.074.06.147.09.22a8.559 8.559 0 0 1-.262-.037c-1.851 1.413-3.56 2.4-5.126 2.96l-.338.115a.5.5 0 0 1-.64-.587c.4-1.696.681-3.197.842-4.504C2.32 14.851 1 12.788 1 10.5c0-4.418 4.925-8 11-8zm5 11.25c2.5 0 4.635 1.555 5.5 3.75a5.913 5.913 0 0 1-5.5 3.75 5.913 5.913 0 0 1-5.5-3.75c.865-2.195 3-3.75 5.5-3.75zM17 15a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5zm0 1c.83 0 1.5.67 1.5 1.5S17.83 19 17 19s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm.111-9.955 3.026 5.987-6.605-1.172 1.351-1.817c-3.661-1.427-7.048.119-8.958 4.111l-1.172-.56c2.266-4.739 6.52-6.521 10.929-4.627l1.43-1.922z",
    fill: "#1500FF"
  }))));
};

export default SvgProportionalArrowsHideIcon;